<template>
  <div id="AiLoading">
    <div class="loader">
      <div class="wrapper">
        <div class="text"> {{ $t('newItem.identifying') }}</div>
        <div class="box"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ailoading",
  data() {
    return {
    };
  },
  props: {
  },
  mounted() {

  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* From Uiverse.io by vinodjangid07 */
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  width: 180px;
  height: 50px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.text {
  z-index: 3;
  font-family: Whitney, -apple-system, Helvetica;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 20px;
  color: #eee;
  opacity: 0.9;
  filter: drop-shadow(2px 2px 0px #0121b0);
}

.box {
  width: 100%;
  height: 100%;
  background-color: rgba(95, 109, 174, .9);
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: loading ease-in-out 0.9s infinite alternate-reverse;
}

@keyframes loading {
  0% {
    transform: translateX(-20px);
  }

  100% {
    transform: translateX(20px);
  }
}

.box::before {
  content: "";
  width: 20px;
  height: 170%;
  background-color: rgba(160, 207, 255, .45);
  position: absolute;
  z-index: 1;
  animation: loading2 ease-in-out 0.9s infinite alternate-reverse;
}

@keyframes loading2 {
  0% {
    transform: translateX(-50px);
  }

  100% {
    transform: translateX(50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ai-loading.vue